import { useEffect } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { Socket } from '../Enums/Socket.enum';

export default function useSocket(key: Socket, run: (data?: any) => void) {
	// @ts-ignore
	const { socket } = useAppContext();

	useEffect(() => {
		socket.on(key, run);
		return () => {
			socket.off(key, run);
		};
	}, []);
}
